<div class="invoice-detail">
    <div class="invoice-header">
        <div class="invoice-header-wrapper">
            <div class="invoice-header-left">
                <button class="invoice-header-button" (click)="closeInvoiceDetailDrawer()">
                    <mat-icon class="back-icon" fontIcon="close"></mat-icon>
                </button>
                <h4 *ngIf="(loading$ | async) === false" class="doc-id">Invoice {{(selectedInvoice?.invoiceNumber)? '#' + selectedInvoice?.invoiceNumber : ''}}</h4>
                <div *ngIf="(loading$ | async) === false">
                    <ng-container *ngIf="selectedInvoice?.status === 'draft'; then draft"></ng-container>
                    <ng-container *ngIf="selectedInvoice?.status === 'new'; then new"></ng-container>
                    <ng-container *ngIf="
                          selectedInvoice?.status === 'in_review';
                          then inApproval
                        "></ng-container>
                    <ng-container *ngIf="
                          selectedInvoice?.status === 'ready_for_payment';
                          then Approved
                        "></ng-container>
                    <ng-container *ngIf="
                          selectedInvoice?.status === 'partially_paid';
                          then partiallyPaid
                        "></ng-container>
                    <ng-container *ngIf="selectedInvoice?.status === 'paid'; then paid"></ng-container>
                    <ng-container *ngIf="
                          selectedInvoice?.status === 'canceled';
                          then cancelled
                        "></ng-container>
                    <ng-container *ngIf="
                          selectedInvoice?.status === 'deleted';
                          then cancelled
                        "></ng-container>
                    <ng-container *ngIf="
                          selectedInvoice?.status === 'rejected';
                          then rejected
                        "></ng-container>
                    <ng-container *ngIf="
                          selectedInvoice?.status === 'expired';
                          then expired
                        "></ng-container>
                    <ng-container *ngIf="selectedInvoice?.status === 'outstanding';
                          then outstanding">
                    </ng-container>
                </div>
            </div>

            <div class="invoice-header-right" *ngIf="selectedInvoice?.status !== 'canceled' && (loading$ | async) === false">
                <button class="btn-white" mat-stroked-button [disabled]="loading$ | async" (click)="toggleEditMode(true)"
                    *ngIf="selectedInvoice?.status !== 'ready_for_payment' && (editMode$ | async) === false  && selectedInvoice?.status !== 'partially_paid' && selectedInvoice?.status !== 'paid' && selectedInvoice?.status !== 'deleted' && selectedInvoice?.status !== 'canceled' && selectedInvoice?.status !== 'rejected' && selectedInvoice?.status !== 'in_review'">
                    <img src="../../../assets/images/edit_icon_2.svg" alt=" " height="20px" width="20px" />
                    <span>Edit</span>
                </button>
                <button mat-stroked-button class="btn-delete" (click)="deleteDialog()"
                *ngIf="(selectedInvoice?.status !== 'paid' && selectedInvoice?.status !== 'canceled' && selectedInvoice?.status !== 'deleted' && selectedInvoice?.status !== 'partially_paid') && (editMode$ | async) === false">
                    <img src="../../../assets/images/delete_icon_red.svg" alt=" " height="20px" width="20px" />
                    <span>Delete</span>
                </button>
                <button class="btn-white" mat-stroked-button (click)="handleRejectInvoice()"
                    *ngIf="selectedInvoice?.status === 'in_review' && (editMode$ | async) === false">
                    <img src="../../../assets/images/cross_icon_2.svg" alt=" " height="20px" width="20px" />
                    <span>Reject</span>
                </button>
                <button class="btn-white" mat-stroked-button (click)="toggleEditMode(false)" *ngIf="editMode$ | async">
                    <span>Cancel</span>
                </button>
                <button mat-stroked-button class="btn-sucess" (click)="handleApproveInvoice()"
                    *ngIf="selectedInvoice?.status === 'in_review' && (editMode$ | async) === false">
                    <img src="../../../assets/images/check_icon_2.svg" alt=" " height="20px" width="20px" />
                    <span>Approve</span>
                </button>
                <button mat-stroked-button class="btn-sucess" (click)="handleApproveInProgress()" [disabled]="sumOfcategoryAmount() !== 0"
                    *ngIf="selectedInvoice?.status === 'new' && (editMode$ | async) === false">
                    <span>Submit</span>
                </button>
                <button mat-stroked-button class="btn-sucess"
                    *ngIf="(selectedInvoice?.status === 'ready_for_payment' || selectedInvoice?.status === 'partially_paid') && (editMode$ | async) === false"
                    (click)="handlePayInvoice()">
                    <img src="../../../assets/images/check_icon_2.svg" alt=" " height="20px" width="20px" />
                    <span>Pay</span>
                </button>
                <button mat-stroked-button class="btn-sucess" (click)="selectedInvoice?.status === 'draft' ? onSaveConfirmation() : onSaveInvoice()" *ngIf="(editMode$ | async)" [disabled]="editInvoiceDetails.categoryAmountDifference !== 0">
                    <span>Save</span>
                </button>
            </div>

        </div>
    </div>
    <div class="invoice-content">
        <div class="invoice-content-left">
            <app-pdf-apryse *ngIf="(loading$ | async) === false else pdfLoader" [filePath]="getDocumentUrl()" [fileName]=""
                [isShowAnnotation]="false"></app-pdf-apryse>
        </div>
    <div class="invoice-content-scroll">
        <div class="invoice-banner" *ngIf="editMode$|async">
            <div class="invoice-banner-container">
                <img src="../../../../assets/images/banner_warning_icon.svg" height="20px" width="20px" alt="icon"/>
                <div class="invoice-banner-content">This invoice was pre-filled via OCR. Please review every field carefully (amounts, dates, VAT, IBAN, etc.) and correct any inaccuracies before saving.</div>
            </div>
        </div>
        <div class="invoice-banner remove-padding" *ngIf="(selectedInvoice?.status === 'new')">
            <div class="invoice-banner-container">
                <img src="../../../../assets/images/banner_warning_icon.svg" height="20px" width="20px" alt="icon"/>
                <div class="invoice-banner-content">This invoice was pre-filled via OCR. Please review every field carefully (amounts, dates, VAT, IBAN, etc.) and correct any inaccuracies before saving.</div>
            </div>
        </div>
        <div class="invoice-banner remove-padding" *ngIf="selectedInvoice?.status === 'in_review'">
            <div class="invoice-banner-container">
                <img src="../../../../assets/images/banner_warning_icon.svg" height="20px" width="20px" alt="icon"/>
                <div class="invoice-banner-content">Approve this invoice to enable payment or link matching transactions to this invoice to reconcile.</div>
            </div>
        </div>
        <div class="invoice-banner remove-padding" *ngIf="selectedInvoice?.status === 'partially_paid'">
            <div class="invoice-banner-container">
                <img src="../../../../assets/images/banner_warning_icon.svg" height="20px" width="20px" alt="icon"/>
                <div class="invoice-banner-content">Clear any pending payments or link additional matching transactions to this invoice to reconcile.</div>
            </div>
        </div>
        <div class="invoice-banner remove-padding" *ngIf="selectedInvoice?.status === 'outstanding'">
            <div class="invoice-banner-container">
                <img src="../../../../assets/images/banner_warning_icon.svg" height="20px" width="20px" alt="icon"/>
                <div class="invoice-banner-content">Make payment or link matching transactions to this invoice to reconcile.</div>
            </div>
        </div>
        <div class="invoice-content-right" [ngClass]="{'banner-hide' : (editMode$ | async) === false}">
            <div class="invoice-detail-view" *ngIf="(editMode$ | async) === false">
                <!-- Invoice Details -->
                <div class="invoice-details-section">
                    <div class="invoice-details-title">
                        Invoice details
                    </div>
                    <div class="invoice-details-content">
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">Invoice number</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{selectedInvoice?.invoiceNumber || '-' }}</span>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">Invoice type</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{selectedInvoice?.type ? (selectedInvoice?.type == 'inbound' ? 'Inbound' : 'Outbound') : ''}}</span>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">Service period</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{selectedInvoice?.servicePeriodStart| date: 'dd MMM, yyyy'}} - {{selectedInvoice?.servicePeriodEnd| date: 'dd MMM, yyyy'}}</span>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">Currency</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{selectedInvoice?.currency || '-'}}</span>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">Issue date</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{ selectedInvoice?.issueDate ? (selectedInvoice.issueDate | date: 'dd MMM, yyyy') : '-' }}
                                </span>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">Due date</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{selectedInvoice?.dueDate ? (selectedInvoice?.dueDate | date: 'dd MMM, yyyy') : '-'}}</span>
                            </div>
                        </div>

                    </div>
                </div>
                <!-- Categorization -->
                <div class="invoice-details-section">
                    <div class="categorization-header">
                        <div class="invoice-details-title">
                            Categorization
                        </div>
                    </div>
                    <div class="invoice-details-content">
                        <div class="invoce-details-lineItems-table">
                            <table mat-table [dataSource]="categorizationDataSource" class="categories-table" [hidden]="loading$|async">
                                <ng-container matColumnDef="category">
                                    <th mat-header-cell *matHeaderCellDef> Category </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{element.category  ? (element.category !== 'uncategorized' ? element.category : '') : ''}}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="taxrate">
                                    <th mat-header-cell *matHeaderCellDef class=""> Tax rate </th>
                                    <td mat-cell *matCellDef="let element" class="">
                                         {{element.taxValue ? ('VAT' +' '+ element.taxValue+ '%') : '-'}}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="amount">
                                    <th mat-header-cell *matHeaderCellDef class=""> Amount </th>
                                    <td mat-cell *matCellDef="let element" class="">
                                        {{((element.amount) | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €'}}
                                    </td>
                                </ng-container>

                                <tr mat-header-row
                                    *matHeaderRowDef="['category', 'taxrate', 'amount'];sticky: true">
                                </tr>
                                <tr mat-row
                                    *matRowDef="let row; columns: ['category','taxrate', 'amount'];">
                                </tr>
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell no-row" colspan="3" style="padding: 1rem">
                                        <div class="no-invoice-found-container">

                                            <div class="text-section">
                                                <div class="supporting-text">
                                                    It looks like there are no line items are avaiable at the
                                                    moment. Please check back later or try adjusting your
                                                    search criteria.
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <table mat-table [dataSource]="[1]" *ngIf="loading$|async">
                                <ng-container matColumnDef="category">
                                    <th mat-header-cell *matHeaderCellDef> Category </th>
                                    <td mat-cell *matCellDef="let element">
                                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                  width: '90%',
                                                  height: '24px',
                                                  marginBottom: 0
                                                }"></ngx-skeleton-loader>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="taxrate">
                                    <th mat-header-cell *matHeaderCellDef> Tax rate </th>
                                    <td mat-cell *matCellDef="let element">
                                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                  width: '90%',
                                                  height: '24px',
                                                  marginBottom: 0
                                                }"></ngx-skeleton-loader>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="amount">
                                    <th mat-header-cell *matHeaderCellDef> Amount </th>
                                    <td mat-cell *matCellDef="let element">
                                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                  width: '90%',
                                                  height: '24px',
                                                  marginBottom: 0
                                                }"></ngx-skeleton-loader>
                                    </td>
                                </ng-container>

                                <tr mat-header-row
                                    *matHeaderRowDef="['category', 'taxrate', 'amount'];sticky: false">
                                </tr>
                                <tr mat-row
                                    *matRowDef="let row; columns: ['category', 'taxrate', 'amount'];">
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- link transaction View -->

                <div class="invoice-details-section transaction-row">
                    <div class="invoice-details-title">
                    </div>
                    <div class="linked-transcation-header">
                        <div class="invoice-details-title">
                            Linked Transactions
                        </div>
                        <ng-container>
                            <button class="linked-add-btn"  [disabled]="selectedInvoice?.status === 'deleted' || selectedInvoice?.status === 'rejected'"
                            *ngIf="(loading$ | async) === false; else button" (click)="linkTransactionPopup('invoice-details')">
                                <img src="../../../assets/images/link_icon.svg" alt=" " height="20px" width="20px" />
                                <span>Link</span>
                            </button>
                        </ng-container>
                    </div>
                    
                    <div class="invoice-details-content">
                        <ng-container *ngIf="showErrorTransaction(selectedInvoice?.outstandingAmount)">
                            <div class="transaction-warning-container">
                                <img src="../../../../assets/images/warning_icon.svg" height="20px" width="20px" alt="icon"/>
                                <div class="transaction-warning-content">The linked transaction exceeds the total invoice amount. Please link the right transaction to submit the invoice</div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="(loading$ | async) === false else transactionLoader">
                            <ng-container *ngIf="linkedTransationLists.length > 0">
                                <div class="linked-details" [ngClass]="{'adding-space' : !last}" *ngFor="let transaction of linkedTransationLists; let last = last">
                                    <div class="trnasaction-description">
                                        <div class="desc-title">Invoice #{{transaction.transactionCode}} Payment</div>
                                        <div class="desc-date">{{transaction.bookingDate ? commonService.formateDate(transaction.bookingDate) : '-'}}</div>
                                    </div>
                                    <div class="trnasaction-amount">
                                        {{((transaction.amount)| number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €'}}
                                    </div>
                                    <div class="trnasaction-delete-icon" (click)="unLinkInvoiceDailog('invoice-details', transaction.transactionId)">
                                        <img src="../../../assets/images/delete_icon.svg"  alt=" " height="20px" width="20px"/>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="unlink-details" *ngIf="linkedTransationLists.length == 0">
                                Link a transaction to this invoice to reconcile
                            </div>
                        </ng-container>
                    </div>
                </div>
                <!-- amount section -->
                <div class="invoice-details-section">
                    <div class="invoice-details-content">
                        <div class="invoice-details-row">
                            <div class="invoice-details-label total">Subtotal</div>
                            <div class="invoice-details-value total">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <div *ngIf="(loading$ | async) === false ">
                                    {{(selectedInvoice?.subTotal? ((selectedInvoice?.subTotal)| number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €'}}
                                </div>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label total">VAT total</div>
                            <div class="invoice-details-value total">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <div *ngIf="(loading$ | async) === false ">
                                    {{((selectedInvoice?.vatTotal) ? ((selectedInvoice?.vatTotal)|number : '1.2'): '0') + ' €'}}
                                </div>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label total">Total</div>
                            <div class="invoice-details-value total">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <div *ngIf="(loading$ | async) === false ">
                                    {{(selectedInvoice?.totalAmount ? ((selectedInvoice?.totalAmount) | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €'}}
                                </div>
                            </div>
                        </div>
                        <div class="invoice-details-row total-section">
                            <div class="invoice-details-label total">Outstanding</div>
                            <div class="invoice-details-value total">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '20px',
                                    'margin-bottom': '10px'
                                  }"></ngx-skeleton-loader>
                                <div *ngIf="(loading$ | async) === false ">
                                    {{(selectedInvoice?.outstandingAmount ? ((selectedInvoice?.outstandingAmount) | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €'}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Counterparties -->
                <div class="invoice-details-section">
                    <div class="invoice-details-title">
                        Counterparty details
                    </div>
                    <div class="invoice-details-content">
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">Company name</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                          width: '200px',
                                          'border-radius': '0',
                                          height: '20px',
                                          'margin-bottom': '10px'
                                        }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{counterPartyName || '-'}}</span>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">Account holder name</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                          width: '200px',
                                          'border-radius': '0',
                                          height: '20px',
                                          'margin-bottom': '10px'
                                        }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{ selectedInvoice?.bankAccount?.account_holder_name || "-"
                                    }}</span>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">IBAN</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                          width: '200px',
                                          'border-radius': '0',
                                          height: '20px',
                                          'margin-bottom': '10px'
                                        }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{ selectedInvoice?.bankAccount?.iban || "-"}}</span>
                            </div>
                        </div>
                        <div class="invoice-details-row">
                            <div class="invoice-details-label">BIC</div>
                            <div class="invoice-details-value">
                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                          width: '200px',
                                          'border-radius': '0',
                                          height: '20px',
                                          'margin-bottom': '10px'
                                        }"></ngx-skeleton-loader>
                                <span *ngIf="(loading$ | async) === false ">{{ selectedInvoice?.bankAccount?.bic || "-"}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Invoice payment log -->
                <div class="invoice-details-section" *ngIf="selectedInvoice.payments && selectedInvoice.payments.length > 0">
                    <div class="invoice-details-title">
                        Payments
                    </div>
                    <div class="invoice-details-content">
                        <div class="invoce-details-lineItems-table">
                            <table mat-table [dataSource]="paymentsDataSource" class="payments-table" [hidden]="loading$|async">
                                <!--Reference column -->
                                <ng-container matColumnDef="reference">
                                    <th mat-header-cell *matHeaderCellDef class="col-reference"> Ref no. </th>
                                    <td mat-cell *matCellDef="let element" class="col-reference">
                                        <a href="javascript:void(0)" (click)="handleShowInvoicePayment(element.id)">{{element.reference}}</a>
                                    </td>
                                </ng-container>
                                <!-- Date Column -->
                                <ng-container matColumnDef="paidAt">
                                    <th mat-header-cell *matHeaderCellDef class="col-date"> Date </th>
                                    <td mat-cell *matCellDef="let element" class="col-date">
                                        {{element.paidAt}}
                                    </td>
                                </ng-container>
                                <!-- amount Column -->
                                <ng-container matColumnDef="amount">
                                    <th mat-header-cell *matHeaderCellDef class="col-price align-left"> Price </th>
                                    <td mat-cell *matCellDef="let element" class="col-price align-left">
                                        {{((element.amount) | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €'}}
                                    </td>
                                </ng-container>
                                <!-- Status Column -->
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef class="col-status align-left"> Status </th>
                                    <td mat-cell *matCellDef="let element" class="col-status align-left column-total">
                                        <span class="col-total">{{(element.status)}}</span>
                                    </td>
                                </ng-container>

                                <tr mat-header-row
                                    *matHeaderRowDef="['reference', 'paidAt', 'amount', 'status'];sticky: true">
                                </tr>
                                <tr mat-row
                                    *matRowDef="let row; columns: ['reference', 'paidAt', 'amount', 'status'];">
                                </tr>
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell no-row" colspan="8" style="padding: 1rem">
                                        <div class="no-invoice-found-container">

                                            <div class="text-section">
                                                <div class="supporting-text">
                                                    It looks like there are no payments are avaiable at the
                                                    moment. Please check back later or try adjusting your
                                                    search criteria.
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <table mat-table [dataSource]="[1]" *ngIf="loading$|async">
                                <!-- Item name column -->
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> Ref no. </th>
                                    <td mat-cell *matCellDef="let element">
                                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                  width: '90%',
                                                  height: '24px',
                                                  marginBottom: 0
                                                }"></ngx-skeleton-loader>
                                    </td>
                                </ng-container>
                                <!-- Quantity Column -->
                                <ng-container matColumnDef="paidAt">
                                    <th mat-header-cell *matHeaderCellDef> Date </th>
                                    <td mat-cell *matCellDef="let element">
                                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                  width: '90%',
                                                  height: '24px',
                                                  marginBottom: 0
                                                }"></ngx-skeleton-loader>
                                    </td>
                                </ng-container>
                                <!-- Price Column -->
                                <ng-container matColumnDef="amount">
                                    <th mat-header-cell *matHeaderCellDef> Amount </th>
                                    <td mat-cell *matCellDef="let element">
                                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                  width: '90%',
                                                  height: '24px',
                                                  marginBottom: 0
                                                }"></ngx-skeleton-loader>
                                    </td>
                                </ng-container>
                                <!-- Status Column -->
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef> Status </th>
                                    <td mat-cell *matCellDef="let element">
                                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                  width: '90%',
                                                  height: '24px',
                                                  marginBottom: 0
                                                }"></ngx-skeleton-loader>
                                    </td>
                                </ng-container>

                                <tr mat-header-row
                                    *matHeaderRowDef="['reference', 'paidAt', 'amount', 'status'];sticky: false">
                                </tr>
                                <tr mat-row
                                    *matRowDef="let row; columns: ['reference', 'paidAt', 'amount', 'status'];">
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>



                <!-- history -->
                 <!-- Invoice Details -->
                  <ng-container *ngIf="invoiceLogsData.length > 0">
                    <div class="invoice-details-section">
                        <div class="invoice-details-title">
                            History
                        </div>
                        <div class="invoice-details-content">
                            <ng-container *ngFor="let historyData of invoiceLogsData">
                                <div class="invoice-details-row">
                                    <div class="invoice-details-label">{{getLabelsByAction(historyData.action).updatedNameLabel}}</div>
                                    <div class="invoice-details-value">
                                        <ng-container *ngIf="(loading$ | async) === false; else loadingValue">
                                            <div class="supplier-icon">{{((historyData?.user?.firstName || '') +' '+ (historyData?.user?.lastName || '')).trim() || (historyData?.user?.email || '') | intialsName}}</div>
                                            <div class="supllier-name">{{commonService.getDisplayName(historyData)}} </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="invoice-details-row row-change">
                                    <div class="invoice-details-label">{{getLabelsByAction(historyData.action).updatedDateLabel}}</div>
                                    <div class="invoice-details-value">
                                        <ng-container *ngIf="(loading$ | async) === false; else loadingValue">
                                            {{commonService.getDateFormatWithTime(historyData?.createdAt, true)}}
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
    
                        </div>
                    </div>
                  </ng-container>
                  <ng-container>
                    <div class="invoice-comments-section">
                        <div class="invoice-comment-history">
                            Comments
                        </div>
                        <div class="invoice-container">
                            <div class="invoice-comments-contaier">
                                <div class="comments-user-icon">{{userName | intialsName}}</div>
                                <textarea class="comment-text-area" [formControl]="commentControl" placeholder="Add a comment..."></textarea>
                            </div>
                            <div class="comment-btn-container" *ngIf="commentControl.value?.trim()">
                                <button type="button" class="comment-btn cancel" (click)="cancelCommentForm()" [disabled]="saveCommentLoading">Cancel</button>
                                <button type="button" class="comment-btn save" (click)="saveCommentForm()" [disabled]="saveCommentLoading">Save</button>
                            </div>
                        </div>
                        <div class="comments-container" (scroll)="onTableScroll($event)" [ngClass]="{'hidden-btn' : !commentControl.value?.trim()}" *ngIf="!commentLoading; else commentLoader">
                            <ng-container *ngFor="let comment of commentList">
                                <div class="invoice-comment-list">
                                    <div class="comments-user-icon">{{((comment?.user?.firstName || '') +' '+ (comment?.user?.lastName || '')).trim() || (comment?.user?.email || '') | intialsName}}</div>
                                    <div class="comment-list-details">
                                        <div class="comment-first-row">
                                            <div class="comments-user-name">{{commonService.getDisplayName(comment)}}</div>
                                            <div class="comments-time-line">{{comment.createdAt | timeago}}</div>
                                        </div>
                                        <div class="comments-info">{{comment.commentText}}</div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="scrollCommnetLoading">
                            <div class="comment-loader">
                                <img src="../../../../assets/images/lazy_loading_spinner.svg" alt="spiner-loader"/>
                            </div>
                        </ng-container>
                    </div>
                  </ng-container>
            </div>
            <div class="form-section" *ngIf="editMode$|async">
            <div class="invoice-edit-view">
                <div class="invoice-edit-details-section">
                    <form #editInvoice="ngForm" (change)="editInvoice.control.markAsTouched()">
                        <div class="invoice-edit-column">
                            <div class="invoice-details-row details-box">
                                <div class="invoice-details-title">
                                    Invoice details
                                </div>
                                <div class="invoice-details-row-items">
                                    <div class="invoice-details-row-item">
                                        <!-- Invoice Type -->
                                        <div class="invoice-details-row-item-container w-half">
                                            <mat-label>Invoice type<span class="mat-form-field-required-marker">&nbsp;*</span></mat-label>
                                            <mat-form-field appearance="fill" *ngIf="(loading$ | async) === false; else loadingValue2" floatLabel="always"
                                                class="comapny-name-field">
                                                <mat-select name="type" #invoiceType [(ngModel)]="editInvoiceDetails.type"
                                                    required disableRipple="true" placeholder="Select" [panelClass]="'select-invoice-type'">
                                                    <mat-option class="select-invoice-option" [value]="'inbound'">
                                                        Inbound
                                                        <img class="arrow-down" src="../../assets/images/inbound_tick.svg"
                                                        matSuffix alt=" " width="20px" height="20px"/>
                                                    </mat-option>
                                                    <mat-option class="select-invoice-option" [value]="'outbound'">
                                                        Outbound
                                                        <img class="arrow-down" src="../../assets/images/outbound_tick.svg"
                                                        matSuffix alt=" " width="20px" height="20px"/>
                                                    </mat-option>
                                                </mat-select>
                                                <img class="arrow-down" [ngClass]="{ open: invoiceType.panelOpen }" src="../../assets/images/arrow-down.svg"
                                                    matSuffix alt="Arrow down icon" />
                                            </mat-form-field>
                                        </div>     

                                        <!-- Invoice Number -->
                                        <div class="invoice-details-row-item-container w-half">
                                            <mat-label>
                                                Invoice number
                                                <span class="mat-form-field-required-marker">*</span>
                                            </mat-label>
                                            <mat-form-field appearance="fill" floatLabel="always" *ngIf="(loading$ | async) === false; else loadingValue2">
                                                <input matInput [(ngModel)]="editInvoiceDetails.invoiceNumber"
                                                    name="invoiceNumber" #invoiceNumber="ngModel" type="text"
                                                    placeholder="Invoice Number" required>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="invoice-details-row-item" floatLabel="always">

                                        <!-- Issue date -->
                                        <div class="invoice-details-row-item-container w-half">
                                            <mat-label>
                                                Issue date
                                            </mat-label>
                                            <mat-form-field appearance="fill" *ngIf="(loading$ | async) === false; else loadingValue2">
                                                <input matInput [matDatepicker]="issueDatePicker"
                                                    [(ngModel)]="editInvoiceDetails.issueDate" placeholder="Issue date"
                                                    [value]="editInvoiceDetails.issueDate" name="issueDate"
                                                    #issueDate="ngModel" required (click)="issueDatePicker.open()">
                                                <mat-datepicker #issueDatePicker></mat-datepicker>
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="issueDatePicker" *ngIf="!issueDate.value">
                                                    <ng-container matDatepickerToggleIcon>
                                                        <img src="../../../../assets/images/calendar_icon_datepicker.svg" alt=" " width="20px" height="20px" />
                                                    </ng-container>
                                                </mat-datepicker-toggle>   
                                                <div matIconSuffix class="clear-date" *ngIf="issueDate.value">
                                                    <button class="btn-clear" (click)="clearIssueDate()">
                                                        <img src="../../../../assets/images/cross_icon_grey.svg" height="20px" width="20px"
                                                            alt=" " />
                                                    </button>
                                                </div>                                               
                                            </mat-form-field>
                                        </div>


                                        <!-- Due Date -->

                                        <div class="invoice-details-row-item-container w-half">
                                            <mat-label>
                                                Due date
                                            </mat-label>
                                            <mat-form-field appearance="fill" floatLabel="always" *ngIf="(loading$ | async) === false; else loadingValue2">
                                                <input matInput [matDatepicker]="dueDatePicker" placeholder="Due date"
                                                    [(ngModel)]="editInvoiceDetails.dueDate" name="dueDate"
                                                    [value]="editInvoiceDetails.dueDate" #dueDate="ngModel" required
                                                    (click)="dueDatePicker.open()">
                                                <mat-datepicker #dueDatePicker></mat-datepicker>
                                                <mat-datepicker-toggle matSuffix [for]="dueDatePicker" *ngIf="!dueDate.value">
                                                    <ng-container matDatepickerToggleIcon>
                                                      <img src="../../../../assets/images/calendar_icon_datepicker.svg" alt=" " />
                                                    </ng-container>
                                                </mat-datepicker-toggle>
                                                <div matIconSuffix class="clear-date" *ngIf="dueDate.value">
                                                    <button class="btn-clear" (click)="clearDueDate()">
                                                        <img src="../../../../assets/images/cross_icon_grey.svg" height="20px" width="20px"
                                                            alt=" " />
                                                    </button>
                                                </div>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                    <div class="invoice-details-row-item">
                                        <div class="invoice-details-row-item-container w-half">
                                            <!-- Service period -->
                                            <mat-label>
                                                <div class="service-help-icon">
                                                    Service period
                                                    <span class="mat-form-field-required-marker">&nbsp;*</span>
                                                    <img src="../../../../assets/images/help-circle.svg" matTooltipPosition="right" matTooltip="The service period during which a company provides goods or services, regardless of when they are billed or paid." alt="help">
                                                </div>
                                            </mat-label>
                                            <mat-form-field class="service-date-range" *ngIf="(loading$ | async) === false; else loadingValue2" [ngClass]="{ 'placeholder': !editInvoiceDetails.servicePeriodStart && !editInvoiceDetails.servicePeriodEnd }">
                                                <mat-date-range-input [rangePicker]="pickerServiceDate">
                                                    <input matStartDate class="service-start-date" placeholder="Start date" [(ngModel)]="editInvoiceDetails.servicePeriodStart" #servicePeriodStart="ngModel" name="servicePeriodStart"/>
                                                    <input matEndDate placeholder="End date" [(ngModel)]="editInvoiceDetails.servicePeriodEnd" #servicePeriodEnd="ngModel" name="servicePeriodEnd"/>
                                                </mat-date-range-input>
                                                <mat-date-range-picker #pickerServiceDate></mat-date-range-picker>
                                                <mat-datepicker-toggle matIconSuffix [for]="pickerServiceDate" *ngIf="!servicePeriodStart.value || !servicePeriodEnd.value">
                                                    <ng-container matDatepickerToggleIcon>
                                                        <img src="../../../../assets/images/calendar_icon_datepicker.svg" alt=" " />
                                                    </ng-container>
                                                </mat-datepicker-toggle>
                                                <div matIconSuffix class="clear-date" *ngIf="servicePeriodStart.value && servicePeriodEnd.value">
                                                    <button class="btn-clear" (click)="clearServiceDate()">
                                                        <img src="../../../../assets/images/cross_icon_grey.svg" height="20px" width="20px"
                                                            alt=" " />
                                                    </button>
                                                </div>
                                            </mat-form-field>
                                        </div>
                                        <!-- Currency -->
                                        <div class="invoice-details-row-item-container w-half">
                                            <mat-label>
                                                Currency
                                                <span class="mat-form-field-required-marker">*</span>
                                            </mat-label>
                                            <mat-form-field appearance="fill" floatLabel="always" *ngIf="(loading$ | async) === false; else loadingValue2">
                                                <input matInput [(ngModel)]="editInvoiceDetails.currency"
                                                    name="currency" #currency="ngModel" disabled type="text"
                                                    placeholder="Currency">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <!-- Categorization -->
                             <div class="invoice-details-row">
                                <div class="categorization-edit-header">
                                    <div class="invoice-details-title">
                                        Categorization
                                    </div>
                                </div>
                                <!-- categorization details overView -->
                                 <div class="category-details">
                                    <div class="invoice-details-row-items category-amount-header">
                                        <div class="invoice-details-row-item">
                                            <div class="invoice-details-row-item-container w-full">
                                                <mat-label>
                                                    Total amount including tax
                                                    <span class="mat-form-field-required-marker">*</span>
                                                </mat-label>
                                                <mat-form-field appearance="fill" floatLabel="always" *ngIf="(loading$ | async) === false; else loadingValue2">
                                                    <input matInput [(ngModel)]="editInvoiceDetails.totalAmount" (ngModelChange)="onCategoryItemChange();calculateOutsourceAmount()"
                                                        name="totalamount" #totalamount="ngModel" type="text"
                                                        placeholder="Currency" required>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="(loading$ | async) === false; else addcategorySectionLoader">
                                        <ng-container *ngFor="let item of editCategorizationItem; let i = index">
                                            <div class="category-split-details">
                                                <div class="category-field-details">
                                                    <div class="field-icon">{{i + 1}}</div>
                                                    <div class="invoice-details-row-items">
                                                        <div class="invoice-details-row-item">
                                                            <div class="invoice-details-row-item-container w-full">
                                                                <mat-label>
                                                                    Category
                                                                    <span class="mat-form-field-required-marker">*</span>
                                                                </mat-label>
                                                                <mat-form-field appearance="fill" floatLabel="always" class="comapny-name-field">
                                                                    <mat-select name="category{{i}}"(openedChange)="clearSearch(i)" [(ngModel)]="item.category" #categoryPanel #category="ngModel" required
                                                                        disableRipple="true" (ngModelChange)="onCategoryItemChange()" placeholder="Select a category">                                                                                                                         
                                                                        <mat-form-field id="categorySearchInput" class="search-input-box">
                                                                            <img src="../../assets/images/search.svg" alt="search" matPrefix />
                                                                            <input matInput type="text"  [(ngModel)]="searchQueries[i]" (ngModelChange)="onSearchChange(i, $event)" [ngModelOptions]="{standalone: true}" class="search-input-box" />
                                                                        </mat-form-field>
                                                                        <mat-optgroup *ngFor="let group of filteredCategoriesMap[i]" [label]="group.type" class="search-category">
                                                                            <mat-option class="closing-name-option" *ngFor="let subItem of group.items" [value]="subItem">
                                                                                {{ subItem.name }}
                                                                            </mat-option>
                                                                        </mat-optgroup>
                                                                    </mat-select>                                                                
                                                                    <img class="arrow-down" [ngClass]="{ open: categoryPanel.panelOpen }" src="../../assets/images/arrow-down.svg"
                                                                        matSuffix alt="Arrow down icon" />
                                                                </mat-form-field>                                                                
                                                            </div>
                                                        </div>
                                                        <div class="invoice-details-row-item">
                                                            <!-- Tax type -->
                                                            <div class="invoice-details-row-item-container w-half">
                                                                <mat-label>
                                                                    Tax type
                                                                    <span class="mat-form-field-required-marker">*</span>
                                                                </mat-label>
                                                                <mat-form-field appearance="fill"
                                                                    floatLabel="always" class="comapny-name-field">
                                                                    <mat-select name="taxtype{{i}}" [(ngModel)]="item.taxValue"
                                                                        #taxPanel #taxtype="ngModel"
                                                                        required
                                                                        disableRipple="true"
                                                                        (ngModelChange)="onCategoryItemChange()"
                                                                        placeholder="Select a taxType">
                                                                        <mat-option class="closing-name-option" *ngFor="let item of taxType"
                                                                            [value]="item.value">
                                                                            {{ item.label }}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                    <img class="arrow-down" [ngClass]="{ open: taxPanel.panelOpen }"
                                                                        src="../../assets/images/arrow-down.svg" matSuffix
                                                                        alt="Arrow down icon" />
                                                                </mat-form-field>
                                                            </div>
                    
                                                            <!-- Total amount -->
                                                            <div class="invoice-details-row-item-container w-half">
                                                                <mat-label>
                                                                    Total amount
                                                                    <span class="mat-form-field-required-marker">*</span>
                                                                </mat-label>
                                                                <mat-form-field appearance="fill" floatLabel="always">
                                                                    <input matInput [(ngModel)]="item.amount"
                                                                        name="amount{{i}}" #amount="ngModel" type="text"
                                                                        (ngModelChange)="onCategoryItemChange()" placeholder="Currency" required>
                                                                </mat-form-field>
                                                            </div>
                    
                                                        </div>
                                                    </div>
                                                    <button class="delete-icon" (click)="removeCatergoryItem(i)" [disabled]="editCategorizationItem.length == 1">
                                                        <img src="../../assets/images/delete_icon.svg" alt="delete_icon"
                                                                    style=" height: 20px;width: 20px;" />
                                                    </button>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                    <div class="add-category-btn" (click)="onAddCategorizationItem()" *ngIf="(loading$| async) === false else addcategoryLoader">
                                        <img src="../../../assets/images/plus_icon_green.svg" alt=" " height="20px" width="20px"/>
                                        <span class="btn-text">Add new category</span>
                                     </div>

                                     <div class="transaction-details" *ngIf="(loading$ | async) === false; else amountdifferenceloader">
                                        <mat-accordion class="transaction-accordion">
                                            <mat-expansion-panel (opened)="panelOpenState = true" class="transation-expanssion"
                                            (closed)="panelOpenState = false">
                                            <mat-expansion-panel-header>
                                            <mat-panel-title>
                                              <div class="title-txt">Total difference in amount</div> 
                                              <div class="title-amount">&#8364;{{(editInvoiceDetails.categoryAmountDifference | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') || '0'}}</div>
                                            </mat-panel-title>
                                            </mat-expansion-panel-header>
                                            <div class="transaction-details">
                                               <div class="transaction-text">Transaction amount</div>
                                               <div class="trnasction-amount">&#8364;{{(editInvoiceDetails.totalAmount | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') || '0'}}</div>
                                            </div>
                                            <div class="transaction-details">
                                                <div class="transaction-text">Sum of splits (Includes VAT)</div>
                                                <div class="trnasction-amount">&#8364;{{(editInvoiceDetails.totalCategoryAmount | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') || '0'}}</div>
                                             </div>
                                        </mat-expansion-panel>
                                        </mat-accordion>
                                     </div>

                                 </div>
                            </div>
                            <!-- linked transaction -->

                            <div class="invoice-details-row">
                                <div class="categorization-edit-header">
                                    <div class="invoice-details-title">
                                        Linked Transactions
                                    </div>
                                    <button class="categories-add-btn"  *ngIf="(loading$ | async) === false; else button"  (click)="linkTransactionPopup('invoice-edit')">
                                        <img src="../../../assets/images/link_icon.svg" alt=" " height="20px" width="20px" />
                                        <span>Link</span>
                                    </button>
                                </div>
                                <ng-container *ngIf="showErrorTransaction(editInvoiceDetails?.outstandingAmount)">
                                    <div class="transaction-warning-container">
                                        <img src="../../../../assets/images/warning_icon.svg" height="20px" width="20px" alt="icon"/>
                                        <div class="transaction-warning-content">The linked transaction exceeds the total invoice amount. Please link the right transaction to submit the invoice</div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="(loading$ | async) === false else transactionLoader"> 
                                    <ng-container *ngIf="linkedTransationLists.length > 0">
                                        <div class="linked-details" *ngFor="let transaction of linkedTransationLists">
                                            <div class="trnasaction-description">
                                                <div class="desc-title">Invoice #{{transaction.transactionCode}} Payment</div>
                                                <div class="desc-date">{{transaction.bookingDate ? commonService.formateDate(transaction.bookingDate) : '-'}}</div>
                                            </div>
                                            <div class="trnasaction-amount">
                                                {{((transaction.amount)| number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €'}}
                                            </div>
                                            <div class="trnasaction-delete-icon" (click)="unLinkInvoiceDailog('invoice-edit', transaction.transactionId)">
                                                <img src="../../../assets/images/delete_icon.svg"  alt=" " height="20px" width="20px"/>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <div class="unlink-details" *ngIf="linkedTransationLists.length == 0">
                                        Link a transaction to this invoice to reconcile
                                    </div>
                                </ng-container>
                            </div>
                            <!-- amount details -->
                             <div class="invoice-details-row">
                                <div class="invoice-details-row-items no-gap">
                                    <div class="invoice-details-row-item">
                                        <!-- Subtotal -->
                                        <div class="invoice-details-row-item-container w-full footer small-title">
                                            <mat-label>
                                                Subtotal
                                            </mat-label>
                                            <div class="small-title-right">
                                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                                    width: '200px',
                                                    'border-radius': '0',
                                                    height: '20px',
                                                    'margin-bottom': '10px'
                                                  }"></ngx-skeleton-loader>
                                                <ng-container *ngIf="(loading$ | async) === false ">
                                                   {{(editInvoiceDetails.subTotal ? (( editInvoiceDetails.subTotal) | number :'1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €'}}
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="invoice-details-row-item">
                                        <!-- VAT Total -->
                                        <div class="invoice-details-row-item-container w-full footer small-title">
                                            <mat-label>
                                                VAT total
                                            </mat-label>
                                            <div class="small-title-right">
                                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                                    width: '200px',
                                                    'border-radius': '0',
                                                    height: '20px',
                                                    'margin-bottom': '10px'
                                                  }"></ngx-skeleton-loader>
                                                <ng-container *ngIf="(loading$ | async) === false ">
                                                    {{(editInvoiceDetails.vatTotal ? (( editInvoiceDetails.vatTotal) | number :'1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €'}}
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="invoice-details-row-item">
                                        <!-- Total -->
                                        <div class="invoice-details-row-item-container w-full footer small-title">
                                            <mat-label>
                                                Total
                                            </mat-label>
                                            <div class="small-title-right">
                                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                                    width: '200px',
                                                    'border-radius': '0',
                                                    height: '20px',
                                                    'margin-bottom': '10px'
                                                  }"></ngx-skeleton-loader>
                                                <ng-container *ngIf="(loading$ | async) === false ">
                                                    {{(editInvoiceDetails.totalAmount ? (editInvoiceDetails.totalAmount | number :'1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €'}}
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="invoice-details-row-item">
                                        <!-- Outstanding -->
                                        <div class="invoice-details-row-item-container w-full footer large-title">
                                            <mat-label>
                                                Outstanding
                                            </mat-label>
                                            <div>
                                                <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                                    width: '200px',
                                                    'border-radius': '0',
                                                    height: '20px',
                                                    'margin-bottom': '10px'
                                                  }"></ngx-skeleton-loader>
                                                <ng-container *ngIf="(loading$ | async) === false ">
                                                    {{(editInvoiceDetails?.outstandingAmount ? ((editInvoiceDetails?.outstandingAmount) | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €'}}
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                             </div>
                            <!-- Counterparty details -->
                            <div class="invoice-details-row">
                                <div class="invoice-details-title">
                                    Counterparty details
                                </div>
                                <div class="invoice-details-row-items">
                                    <div class="invoice-details-row-item">
                                        <!-- Company name -->

                                        <div class="invoice-details-row-item-container w-full">
                                            <mat-label>
                                                Company name
                                                <span class="mat-form-field-required-marker">*</span>
                                            </mat-label>
                                            <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                                width: '100%',
                                                'border-radius': '0',
                                                height: '44px',
                                                'margin-bottom': '10px'
                                              }"></ngx-skeleton-loader>
                                            <mat-form-field appearance="fill" *ngIf="(loading$ | async) === false"
                                                floatLabel="always" class="comapny-name-field">
                                                <input matInput [(ngModel)]="counterPartyName"
                                                    name="counterparty" #counterparty="ngModel" type="text"
                                                    placeholder="Company name" required>
                                            </mat-form-field>
                                        </div>



                                    </div>

                                    <div class="invoice-details-row-item">

                                        <!--IBAN -->

                                        <div class="invoice-details-row-item-container w-full">
                                            <mat-label>
                                                IBAN
                                                <span class="mat-form-field-required-marker">*</span>
                                            </mat-label>
                                            <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                                width: '100%',
                                                'border-radius': '0',
                                                height: '44px',
                                                'margin-bottom': '10px'
                                              }"></ngx-skeleton-loader>
                                            <mat-form-field appearance="fill" *ngIf="(loading$ | async) === false"
                                                floatLabel="always">
                                                <input matInput [(ngModel)]="editBankAccount.iban" name="iban"
                                                    #iban="ngModel" type="text" placeholder="IBAN" required>

                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="invoice-details-row-item">

                                        <!-- BIC -->

                                        <div class="invoice-details-row-item-container w-full">
                                            <mat-label>
                                                SIWFT/BIC
                                                <span class="mat-form-field-required-marker">*</span>
                                            </mat-label>
                                            <ngx-skeleton-loader *ngIf="(loading$ | async) === true" [theme]="{
                                                width: '100%',
                                                'border-radius': '0',
                                                height: '44px',
                                                'margin-bottom': '10px'
                                              }"></ngx-skeleton-loader>
                                            <mat-form-field appearance="fill" *ngIf="(loading$ | async) === false"
                                                floatLabel="always">
                                                <input matInput [(ngModel)]="editBankAccount.bic" name="bic"
                                                    #bic="ngModel" type="text" placeholder="BIC" required>

                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                                     
                        </div>

                    </form>
                </div>
            </div>
            </div>
        </div>
    </div>


    </div>
</div>
<app-qrcode [qrCodeBase64]="qrCodeData.qrcode" [metaData]="qrCodeData.embeddedMetaData"
    [isReadyOnly]="isQrCodeReadOnly"
    [status]="selectedInvoice.status" (closeQrCodeEvent)="closeQrCode()" (markAsPaidEvent)="markAsPaid()"
    *ngIf="showQrCode$ | async">
</app-qrcode>

<app-payment-input 
    [invoiceData]="selectedInvoice"
    [selectedVehicle]="selectedVehicle"
    (closePaymentInputEvent)="closePaymentInput()"
    (proceedToPaymentEvent)="handlePaymentProceed($event)"
    *ngIf="showPaymentInput$ | async">
</app-payment-input>
<div class="main-loader" *ngIf="mainLoader$ | async">
    <mat-spinner class="spinner"></mat-spinner>
</div>
<ng-template #draft>
    <div class="status-badge draft">
        <img src="../../assets/images/edit_icon.svg" alt="edit-icon" />
        <span>Draft</span>
    </div>
</ng-template>
<ng-template #new>
    <div class="status-badge new">
        <img src="../../assets/images/bolt_icon.svg" alt="new icon" />
        <span>New</span>
    </div>
</ng-template>
<ng-template #inApproval>
    <div class="status-badge in-approval">
        <img src="../../assets/images/clock_icon.svg" alt="approval icon" />
        <span>In Approval</span>
    </div>
</ng-template>
<ng-template #Approved>
    <div class="status-badge in-approval">
        <img src="../../assets/images/clock_icon.svg" alt="approval icon" />
        <span>Approved</span>
    </div>
</ng-template>
<ng-template #toBePaid>
    <div class="status-badge to-be-paid">
        <img src="../../assets/images/clock_icon.svg" alt="to paid icon" />
        <span>To be Paid</span>
    </div>
</ng-template>
<ng-template #partiallyPaid>
    <div class="status-badge in-approval">
        <img src="../../assets/images/clock_icon.svg" alt="partial icon" />
        <span>Partially Paid</span>
    </div>
</ng-template>
<ng-template #paid>
    <div class="status-badge paid">
        <img src="../../assets/images/check_icon.svg" alt="paid icon" />
        <span>Paid</span>
    </div>
</ng-template>
<ng-template #cancelled>
    <div class="status-badge cancelled">
        <img src="../../assets/images/cross_icon.svg" alt="cancelled icon" />
        <span>Deleted</span>
    </div>
</ng-template>
<ng-template #rejected>
    <div class="status-badge rejected">
        <img src="../../assets/images/cross_icon.svg" alt="rejected icon" />
        <span>Rejected</span>
    </div>
</ng-template>
<ng-template #expired>
    <div class="status-badge expired">
        <img src="../../assets/images/warning_icon.svg" alt="expired icon" />
        <span>Expired</span>
    </div>
</ng-template>
<ng-template #outstanding>
    <div class="status-badge expired">
        <img src="../../assets/images/clock_icon_red.svg" alt="outstanding icon" />
        <span>Outstanding</span>
    </div>
</ng-template>
<ng-template #loadingValue>
    <ngx-skeleton-loader [theme]="{
        width: '200px',
        'border-radius': '0',
        height: '20px',
        'margin-bottom': '10px'
      }"></ngx-skeleton-loader>
</ng-template>
<ng-template #loadingValue2>
    <ngx-skeleton-loader [theme]="{
        'border-radius': '0',
        height: '44px',
      }"></ngx-skeleton-loader>
</ng-template>
<ng-template #pdfLoader>
    <ngx-skeleton-loader count="1" appearance="line" [theme]="{
        width: '100%',
        height: '100%'
      }"></ngx-skeleton-loader>
</ng-template>
<ng-template #button>
    <div style="margin-left: auto;">
        <ngx-skeleton-loader [theme]="{
            height: '34px',
            width: '86px'
          }"></ngx-skeleton-loader>
    </div>
</ng-template>
<ng-template #commentLoader>
    <div *ngFor="let i of [1,2,3]">
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                width: '90%',
                height: '24px',
                marginBottom: 10,
                marginLeft: '8%'
            }"></ngx-skeleton-loader>

            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                width: '90%',
                height: '12px',
                marginBottom: 30,
                marginLeft: '8%'
            }"></ngx-skeleton-loader>
    </div>
</ng-template>
<ng-template #addcategoryLoader>
    <div style="margin-top: 30px;">
        <ngx-skeleton-loader [theme]="{
            height: '24px',
            width: '160px'
          }"></ngx-skeleton-loader>
    </div>
</ng-template>

<ng-template #addcategorySectionLoader>
 <div class="invoice-details-row-items">
    <div class="invoice-details-row-item">
        <div class="invoice-details-row-item-container w-full">
            <mat-label>
                Category
                <span class="mat-form-field-required-marker">*</span>
            </mat-label>
            <ngx-skeleton-loader [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '44px',
                'margin-bottom': '10px'
                }"></ngx-skeleton-loader>
        </div>

    </div>
    <div class="invoice-details-row-item">
        <div class="invoice-details-row-item-container w-half">
            <mat-label>
                Tax type
                <span class="mat-form-field-required-marker">*</span>
            </mat-label>
            <ngx-skeleton-loader [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '44px',
                'margin-bottom': '10px'
                }"></ngx-skeleton-loader>
        </div>

        <div class="invoice-details-row-item-container w-half">
            <mat-label>
                Total amount
                <span class="mat-form-field-required-marker">*</span>
            </mat-label>
                <ngx-skeleton-loader [theme]="{
                    'border-radius': '0',
                    height: '44px',
                  }"></ngx-skeleton-loader>
        </div>
    </div>
</div>
</ng-template>
<ng-template #transactionLoader>
    <div style="margin-bottom: 10px; width: 100%;">
        <ngx-skeleton-loader [theme]="{
            height: '40px',
            width: '100%',
          }"></ngx-skeleton-loader>
    </div>
    <div style="margin-top: 10px; width: 100%;">
        <ngx-skeleton-loader [theme]="{
            height: '40px',
            width: '100%',
          }"></ngx-skeleton-loader>
    </div>
</ng-template>

<ng-template #amountdifferenceloader>
    <div style="width: 100%;">
        <ngx-skeleton-loader [theme]="{
            height: '40px',
            width: '100%',
          }"></ngx-skeleton-loader>
    </div>
</ng-template>
<ng-template #outstanding>
    <div class="status-badge expired">
        <img src="../../assets/images/clock_icon_red.svg" alt="outstanding icon" />
        <span>Outstanding</span>
    </div>
</ng-template>
